import { render } from "./CandidatePreviewTab.vue?vue&type=template&id=3615fd46&scoped=true"
import script from "./CandidatePreviewTab.vue?vue&type=script&lang=js"
export * from "./CandidatePreviewTab.vue?vue&type=script&lang=js"

import "./CandidatePreviewTab.vue?vue&type=style&index=0&id=3615fd46&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3615fd46"]])

export default __exports__